<template>
  <div>
    <button class="btn btn-primary" @click="submit">Log in</button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          username: '',
          password: '',
        },

        error: null
      }
    },

    watch: {
      form: {
        deep: true,

        handler() {
          this.error = null
        }
      }
    },

    methods: {
      submit() {
        this.axios.get('/', { withCredentials: true }).then(response => {
          const data = response.data
          const token = data.token
          sessionStorage.setItem('token', token);

          this.$socket.client.io.opts.query = { token };
          this.$socket.client.open();
          this.$router.push('/');
        }, (res) => {
          this.error = res.response.data.error
        });
      }
    }
  }
</script>

<style scoped>
  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
